import { inject, Injectable } from '@angular/core';
import { RootServicesModule } from './root-services.module';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@app-environment';
import { TranslationData } from '../interfaces/translation.interface';

@Injectable({
    providedIn: RootServicesModule
})
export class TranslationService {
    private readonly http = inject(HttpClient);

    public getLanguage(lang: string): Observable<TranslationData> {
        return this.http.get<TranslationData>(`${environment.gatewayAPI}/translations/${lang}`);
    }

    public getLanguages(): Observable<string[]> {
        return this.http.get<string[]>(`${environment.gatewayAPI}/translations/languages`);
    }
}
